































































































































import {Component, Prop} from 'vue-property-decorator'
import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'

@Component
export default class BridgeProceedButton extends MixinScreenSize {
  @Prop({type: Boolean, required: true}) isDisabled!: boolean
  @Prop({type: String, required: true}) popoverText!: string
  @Prop({type: Boolean, required: true}) isMobileDisclaimerOpened!: boolean

  handleProceedClick() {
    this.$emit('proceed')
  }
}
